(function () {
	const headerMobile = () => {
		const headerSection = document.querySelector(".header-mobile-section");
		const header = document.querySelector(".header-mobile");
		let scrollPos = 0;
		window.addEventListener("scroll", () => {
			if (!header.classList.contains("sticky-header")) {
				return;
			}
			const scroll = window.scrollY;
			if (scroll > 40) {
				header.classList.add("header-scroll");
			} else {
				header.classList.remove("header-scroll");
			}
			if (scroll > scrollPos) {
				// down
				if (scroll > 100) {
					hideHeader();
				} else {
					showHeader();
				}
			} else {
				// up
				showHeader();
			}
			scrollPos = scroll;
		});
		function hideHeader() {
			if (header.classList.contains("sticky-header-always")) {
				return "";
			}
			headerSection.classList.add("hide");
		}
		function showHeader() {
			headerSection.classList.remove("hide");
		}

		const burger = document.querySelector(".header-mobile__burger");
		const mobileMenu = document.querySelector(".header-mobile__menu");
		const mobileAnimateBg = document.querySelector(".animate-bg");
		var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
		var headerUiRegions = [
			document.querySelector(".header-mobile__search"),
			document.querySelector(".header-mobile__logo__wrapper"),
			document.querySelector(".header-mobile__right"),
		].filter(Boolean);

		function setHeaderUiInert(active) {
			headerUiRegions.forEach(function (el) {
				if (active) {
					el.setAttribute("inert", "");
					el.setAttribute("aria-hidden", "true");
				} else {
					el.removeAttribute("inert");
					el.setAttribute("aria-hidden", "false");
				}
			});
		}

		// Custom: set inert on sibling elements to trap screen reader virtual focus
		function setSiblingsInert(active) {
			var siblings = headerSection.parentElement.children;
			for (var i = 0; i < siblings.length; i++) {
				if (siblings[i] !== headerSection) {
					if (active) {
						siblings[i].setAttribute("inert", "");
					} else {
						siblings[i].removeAttribute("inert");
					}
				}
			}
		}

		burger.addEventListener("click", function (e) {
			e.preventDefault();
			this.classList.toggle("active");
			mobileMenu.classList.toggle("active");
			mobileAnimateBg.classList.toggle("active");
			document.body.classList.toggle("overflow-hidden");
			// Custom: sync aria-expanded and aria-label on burger button
			var isOpen = mobileMenu.classList.contains("active");
			if (isOpen) {
				this.removeAttribute("aria-expanded");
			} else {
				this.setAttribute("aria-expanded", "false");
			}
			this.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
			// Custom: inert siblings and move focus when opening, restore when closing
			setSiblingsInert(isOpen);
			setHeaderUiInert(isOpen);
			mobileMenu.inert = !isOpen;
			if (!isOpen) {
				burger.focus();
			}
		});

		// Custom: close mobile menu on Escape
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && mobileMenu.classList.contains("active")) {
				burger.classList.remove("active");
				mobileMenu.classList.remove("active");
				mobileAnimateBg.classList.remove("active");
				document.body.classList.remove("overflow-hidden");
				burger.setAttribute("aria-expanded", "false");
				burger.setAttribute("aria-label", "Open menu");
				setSiblingsInert(false);
				setHeaderUiInert(false);
				mobileMenu.inert = true;
				burger.focus();
			}
		});

		// Custom: trap keyboard focus inside .header-mobile-section when menu is open
		document.addEventListener("keydown", function (e) {
			if (e.key !== "Tab" || !mobileMenu.classList.contains("active")) return;

			var focusableEls = Array.prototype.slice.call(
				headerSection.querySelectorAll(focusableSelector)
			).filter(function (el) {
				return el.offsetParent !== null;
			});

			if (focusableEls.length === 0) return;

			var firstEl = focusableEls[0];
			var lastEl = focusableEls[focusableEls.length - 1];

			if (e.shiftKey) {
				if (document.activeElement === firstEl) {
					e.preventDefault();
					lastEl.focus();
				}
			} else {
				if (document.activeElement === lastEl) {
					e.preventDefault();
					firstEl.focus();
				}
			}
		});

		const mobileMenuList = document.querySelectorAll(
			".header-mobile__menu-header a"
		);
		mobileMenuList.forEach((item) => {
			item.addEventListener("click", function (event) {
				event.preventDefault();
				const id = this.getAttribute("href");
				mobileMenuList.forEach((_item) => {
					_item.parentElement.classList.remove("active");
				});
				this.parentElement.classList.add("active");
				const menus = document.querySelectorAll(".header-mobile__menus > li");
				const current = document.querySelector(id);
				menus.forEach((_menu) => {
					_menu.style.display = "none";
				});
				current.style.display = "block";
			});
		});
		
		let resizeTimeout;
		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				const isDesktop = window.innerWidth >= 1100;

				if (isDesktop) {
					burger.classList.remove("active");
					mobileMenu.classList.remove("active");
					mobileAnimateBg.classList.remove("active");
					document.body.classList.remove("overflow-hidden");
					// Custom: reset aria state and remove inert when menu auto-closes on desktop
					burger.setAttribute("aria-expanded", "false");
					burger.setAttribute("aria-label", "Open menu");
					setSiblingsInert(false);
					setHeaderUiInert(false);
					mobileMenu.inert = true;
				}
			}, 300);
		});
	};

	document.addEventListener("shopify:section:load", headerMobile);
	headerMobile();
})();
